const GOOGLE_MAP_KEY = process.env.REACT_APP_GOOGLE_MAP_API_KEY || ''

export const loadGoogleScript = () => {
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAP_KEY}&libraries=places&callback=initGoogleAutocomplete`;
    script.async = true;
    document.body.appendChild(script);
    return script; // Return the script element for cleanup
};